import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import trTranslations from './locales/tr.json';

// Tarayıcı dilini algıla
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Türkçe ise TR, değilse ENG
  return langCode === 'tr' ? 'tr' : 'en';
};

// localStorage'dan dil oku veya tarayıcı dilini kullan
const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('owlex-language');
  if (savedLanguage && (savedLanguage === 'tr' || savedLanguage === 'en')) {
    return savedLanguage;
  }
  return getBrowserLanguage();
};

const initialLanguage = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      tr: {
        translation: trTranslations
      }
    },
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Dil değiştiğinde localStorage'a kaydet
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('owlex-language', lng);
});

export default i18n;

